'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLeafClusters = exports.getClustersBelow = exports.createDendrogram = exports.createClusterDictionary = undefined;

var _lodash = require('lodash');

var _distanceMatrix = require('./distanceMatrix');

var distanceMatrixLib = _interopRequireWildcard(_distanceMatrix);

var _cluster = require('./cluster');

var clusterLib = _interopRequireWildcard(_cluster);

var _screePlot = require('./screePlot');

var screePlotLib = _interopRequireWildcard(_screePlot);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// √
// Lib
var createClusterDictionary = exports.createClusterDictionary = function createClusterDictionary(clusters) {
    return clusters.reduce(function (dictionary, cluster) {
        dictionary[cluster.id] = cluster;
        return dictionary;
    }, {});
};

/**
 * Lance William algorithm uses previously computed values of the minimum distances of the existing clusters to
 * determine the new minimum distance of the new cluster.
 */


// Distance Matrix
var lanceWilliamDistanceFn = function lanceWilliamDistanceFn(distanceMatrix) {
    return function (newCluster, existingCluster) {
        return Math.min(distanceMatrixLib.getDistance(distanceMatrix, newCluster.children[0].id, existingCluster.id), distanceMatrixLib.getDistance(distanceMatrix, newCluster.children[1].id, existingCluster.id));
    };
};

/**
 * This function creates a binary tree (dendrogram) of clusters using "hierarchical agglomerative clustering".
 * It uses the "single linkage" method to determine which clusters to merge.
 */
// √
var createDendrogram = exports.createDendrogram = function createDendrogram(initialClusters, distanceFn, autoClusterDistance) {
    var rootCluster = void 0;

    var autoClusterDistSquared = autoClusterDistance * Math.abs(autoClusterDistance);
    var screePlot = screePlotLib.createEmptyScreePlot(autoClusterDistSquared);

    var clusterDictionary = createClusterDictionary(initialClusters);
    var distanceMatrix = distanceMatrixLib.createDistanceMatrix(initialClusters, distanceFn);

    // An array of the distances which have been used to create the dendrogram
    var usedDistances = [];
    var minDistance = distanceMatrixLib.getMinDistance(distanceMatrix);
    while (minDistance) {
        usedDistances.push(minDistance);

        var cluster1 = clusterDictionary[minDistance.clusters[0]];
        var cluster2 = clusterDictionary[minDistance.clusters[1]];

        // Add to scree plot - The minimum distance is used as the variance of the plot
        screePlot = screePlotLib.addPoint(screePlot, Math.pow(minDistance.dist / 2, 2));

        // Merge clusters
        var mergedCluster = clusterLib.mergeClusters(cluster1, cluster2, screePlot.currMaxHeight);

        // Remove the merged clusters from the dictionary
        delete clusterDictionary[cluster1.id];
        delete clusterDictionary[cluster2.id];

        // Get the current list of clusters
        var clusters = (0, _lodash.values)(clusterDictionary);
        // Use lance williams to calculate the distance between other clusters and add them to the distance matrix
        distanceMatrix = distanceMatrixLib.addCluster(distanceMatrix, clusters, mergedCluster, lanceWilliamDistanceFn(distanceMatrix));

        // Remove old clusters from the distances array
        distanceMatrix = distanceMatrixLib.removeClusters(distanceMatrix, cluster1.id, cluster2.id);

        // Add the new cluster to the dictionary
        clusterDictionary[mergedCluster.id] = mergedCluster;

        minDistance = distanceMatrixLib.getMinDistance(distanceMatrix);
        rootCluster = mergedCluster;
    }

    return {
        rootCluster: rootCluster,
        screePlot: screePlot,
        distanceMatrix: distanceMatrix,
        usedDistances: usedDistances
    };
};

var sliceCluster = function sliceCluster(cluster, sliceHeight, matchingClusters) {
    if (!cluster) return matchingClusters;

    // If this cluster is above the slice height we need to recursively checking the children
    if (cluster.height > sliceHeight) {
        sliceCluster(cluster.children[0], sliceHeight, matchingClusters);
        sliceCluster(cluster.children[1], sliceHeight, matchingClusters);
    } else {
        // Otherwise this cluster should be added to the matching clusters
        matchingClusters.push(cluster);
    }
    return matchingClusters;
};

// √
var getClustersBelow = exports.getClustersBelow = function getClustersBelow(dendrogram, sliceHeight) {
    return sliceCluster(dendrogram, sliceHeight, []);
};

var getLeafClusters = exports.getLeafClusters = function getLeafClusters(cluster) {
    var matchingClusters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    if (!cluster) return matchingClusters;

    if (!cluster.children.length) {
        matchingClusters.push(cluster);
    } else {
        getLeafClusters(cluster.children[0], matchingClusters);
        getLeafClusters(cluster.children[1], matchingClusters);
    }

    return matchingClusters;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/documentOrder/structures/dendrogram.js
// module id = 791
// module chunks = 0